import React, { useEffect, useState } from 'react';
import { getdata } from '../../util/global';
import AdminSubscriptionTable from './AdminSubscriptionTable';
import AdminSubscriptionForm from './AdminSubscriptionForm';

export default function AdminSubscription() {
  const [subscriptiondata, setsubscriptiondata] = useState<any[]>([]);
  const [showmodal, setshowmodal] = useState('');
  const [formdata, setformdata] = useState<any>({ enddate: '' });

  const loaddata = async () => {
    const res = await getdata({ filter: { datatype: 'subscriptiondata' } });
    setsubscriptiondata(res.reverse() || []);
  };

  useEffect(() => {
    loaddata();
  }, []);

  const openedit = (item: any) => {
    setformdata(item);
    setshowmodal('showsubscriptionform');
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <h3 style={{ margin: 0 }}>Admin Subscriptions</h3>
        <button className="btn btn-outline-secondary btn-sm" onClick={loaddata}>
          Refresh
        </button>
      </div>

      <div className="card shadow-sm p-3">
        <AdminSubscriptionTable subscriptiondata={subscriptiondata} openedit={openedit} />
      </div>

      <AdminSubscriptionForm
        showmodal={showmodal}
        setshowmodal={setshowmodal}
        formdata={formdata}
        setformdata={setformdata}
        fetchdata={loaddata}
      />
    </div>
  );
}
